import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {trackByValue} from '../../utils/track-by';
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {GlobalService} from "../../../app/services/global.service";
import {ActivatedRoute} from "@angular/router";

@UntilDestroy()
@Component({
  selector: 'app-breadcrumbs',
  template: `
    <!--    <div class="flex items-center">-->
    <!--      <app-breadcrumb>-->
    <!--        <a [routerLink]="['/']">-->
    <!--          <mat-icon svgIcon="mat:home" class="icon-sm"></mat-icon>-->
    <!--        </a>-->
    <!--      </app-breadcrumb>-->
    <!--      <ng-container *ngFor="let crumb of updatedCrumbs?.length ? updatedCrumbs : crumbs; let last = last; trackBy: trackByValue">-->
    <!--        <div class="w-1 h-1 bg-gray rounded-full ltr:mr-2 rtl:ml-2"></div>-->
    <!--        <app-breadcrumb>-->
    <!--          <a *ngIf="last">{{ crumb.title | translate}}</a>-->
    <!--          <a *ngIf="!last" [routerLink]="[crumb.route]">{{ crumb.title | translate}}</a>-->
    <!--        </app-breadcrumb>-->
    <!--      </ng-container>-->
    <!--    </div>-->
    <div class="flex items-center">
      <app-breadcrumb>
        <a [routerLink]="['/']">
          <mat-icon svgIcon="mat:home" class="icon-sm"></mat-icon>
        </a>
      </app-breadcrumb>
      <div class="w-1 h-1 bg-gray rounded-full ltr:mr-2 rtl:ml-2"
           style="width: 5px;margin-top: 7px;color: grey;height: 5px;"></div>
      <lib-breadcrumbs class="breadcrumb"></lib-breadcrumbs>
    </div>`,
})
export class BreadcrumbsComponent implements OnInit, OnDestroy {

  @Input() crumbs: any[] = [];
  updatedCrumbs: any[] = [];

  trackByValue = trackByValue;

  constructor(private globalService: GlobalService,
              private activatedRoute: ActivatedRoute,
              private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    // this.subscribeToCrumbs();
  }

  subscribeToCrumbs() {
    this.globalService.crumbsObservable$.pipe(untilDestroyed(this)).subscribe((crumb: any) => {
      if (crumb) {
        this.updatedCrumbs = this.crumbs;
        const shifted = this.crumbs[crumb?.index];
        this.updatedCrumbs[crumb?.index] = {
          title: crumb.title,
          route: crumb?.route
        };
        this.updatedCrumbs.push(shifted);
        // console.log('this.crumbs', this.updatedCrumbs)
        this.cdr.detectChanges();
      }
    });
  }

  ngOnDestroy() {
    this.updatedCrumbs = [];
  }
}
